export default __webpack_public_path__ + "static/media/fullscreen.72577e9f.svg";